import type { DocMigration } from "../docMigration";

const ELEVATION_STYLE = "elevationStyle";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_269: DocMigration = {
  maxSchemaVersion: "0.0.269",
  description: "Clear the isDefault property for all doc ref'd elevations",
  apply(json: any) {
    for (const elevationId in json.elevations) {
      json.elevations[elevationId].isDefault = false;
    }

    const elevationOptionSet = json.optionSets[ELEVATION_STYLE];
    const defaultElevation = elevationOptionSet?.defaultValue;

    if (json.elevations[defaultElevation]) {
      json.elevations[defaultElevation].isDefault = true;
    } else {
      // Set the first non doc-ref'd elevation as the default
      const elevationIds = Object.keys(json.elevations);
      const firstElevationId = elevationIds.find((id) => !json.entityRefs[id]);

      if (firstElevationId) {
        json.elevations[firstElevationId].isDefault = true;
        // If all elevations are doc ref'd, ensure there is a default set
      } else if (!elevationIds.some((id) => json.elevations[id].isDefault)) {
        json.elevations[elevationIds[0]].isDefault = true;
      }
    }

    return json;
  },
};

export default migration_0_0_269;
